/* eslint-disable no-console */
import React, {ReactNode, useEffect} from 'react';
import {requestNotifications} from 'react-native-permissions';

import platformConfig from '/config/platform.config';
import {setupATT} from '/util/ATT.util';
import {requestUserPermission} from '/util/push-notifications/push-notifications.util';

interface UserConsentProviderProps {
  children: ReactNode;
}

const requestPermissionsIos = async () => {
  return await requestUserPermission();
};

export const UserConsentProvider: React.FC<UserConsentProviderProps> = ({
  children = null,
}) => {
  useEffect(() => {
    const handlePermissions = async () => {
      try {
        if (platformConfig.getOS() === 'ios') {
          await requestPermissionsIos();
        } else {
          await requestNotifications(['alert', 'sound']);
        }
        await setupATT();
      } catch (err) {
        console.warn('Consent setup error:', err);
      }
    };

    handlePermissions();
  }, []);

  return <>{children}</>;
};
